import { useMediaQuery } from '@mui/material'
import classNames from 'classnames'
import { useState } from 'react'
import Info from 'src/components/common/Info'
import RoundInfo from 'src/components/common/RoundInfo'
import { PROJECTS_DELIVERED } from 'src/constants/stats'
import { imageUrl } from 'src/utils'

const trustItems: { iconPath: string; descriptionText: string; bgColor?: string }[] = [
  {
    iconPath: 'Card1.svg',
    descriptionText: 'Expert “software doctors” with years of hands-on web and app experience.',
    bgColor: '#F8F8F8',
  },
  {
    iconPath: 'Card2.svg',
    descriptionText: `Proven recovery rate—over ${PROJECTS_DELIVERED}+ successful treatments delivered.`,
    bgColor: '#F3F1F2'
  },
  {
    iconPath: 'Card3.svg',
    descriptionText: 'Seamless experiences across modern browsers and devices.',
  },
  {
    iconPath: 'Card4.svg',
    descriptionText: 'A design-first approach that keeps your software both healthy and beautiful.',
  },
]

const ClientTrustDiagnosis = () => {
  const [activeCard, setActiveCard] = useState(0)
  const isLessThan640 = useMediaQuery('(max-width: 640px)')
  // lg: in Tailwind starts at 1024px, and max-width: 1024px is also true there, so the
  // four-column grid and the side-image layout would apply at the same time.
  const isLessThan1024 = useMediaQuery('(max-width: 1023px)')
  const isTablet = !isLessThan640 && isLessThan1024

  const listOrGridClasses = isLessThan640
    ? 'flex flex-col space-y-1 px-3'
    : 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-6 px-6 lg:px-8'

  return (
    <div className="flex flex-col items-center justify-center w-full mb-6 md:mb-8 lg:mb-12 ">
      <RoundInfo containerClasses="mb-4 md:mb-6 mt-6 md:mt-8">{'Why Us?'}</RoundInfo>

      <Info
        variant={'h2'}
        className="lg:!text-[42px] md:!text-[28px] !text-[28px] text-center"
        containerClasses="w-[90%] mdmax:w-[100%] breaktwomin:w-[50%] mb-8 md:mb-10 lg:mb-12"
      >
        {'Why Clients Trust Our Diagnosis'}
      </Info>

      <div className={`${listOrGridClasses} items-stretch`} onMouseLeave={() => setActiveCard(0)}>
        {trustItems.map((item, index) => {
          const highlighted = activeCard === index
          const surfaceColor = highlighted ? '#AEAB00' : item.bgColor || '#F8F8F8'
          const illustration =           
              <img
                src={imageUrl(item.iconPath)}
                alt={`Trust card ${index + 1}`}
                className="max-h-full max-w-full object-contain"
              />

          return (
            <div
              key={index}
              onMouseEnter={() => setActiveCard(index)}
              className={classNames(
                'relative border-2 shadow-sm transition-all duration-200 hover:z-10 hover:-translate-y-1 hover:scale-[1.04]',
                isLessThan640
                  ? 'flex flex-row items-center w-full min-h-[100px] rounded-xl pl-5 pr-20 py-4'
                  : isTablet
                  ? 'flex flex-row items-center w-full min-h-[128px] rounded-2xl pl-6 pr-28 py-5'
                  : 'flex flex-col justify-between text-center rounded-[16px] overflow-hidden md:max-w-[300px]',
              )}
              style={{
                backgroundColor: surfaceColor,
                borderColor: highlighted ? '#000000' : '#E5E7EB',
              }}
            >
              {(isLessThan640 || isTablet) ? (
                <div
                  className={classNames(
                    'pointer-events-none absolute top-1/2 flex -translate-y-1/2 items-center justify-center',
                    isTablet ? 'right-4 h-[104px] w-[104px]' : 'right-3 h-[80px] w-[80px]',
                  )}>
                    <img src={imageUrl(item.iconPath)} alt="" className="h-full w-full object-contain" />
                </div>
              ) : (
                <div className="flex items-start justify-center w-full h-[200px] px-5 pt-4 pb-2">
                  {illustration}
                </div>
              )}

              <div className={
                isLessThan640
                  ? 'flex-1 pl-5 pr-3 py-4'
                  : isTablet
                  ? 'flex-1 pr-6 py-2'
                  : 'flex flex-1 items-start justify-start px-8 pt-1 pb-5'
              }>
                <p
                  className={isLessThan640 || isTablet ? "text-[16px] md:text-[17px] font-medium leading-snug font-['ABeeZee'] text-left" : "text-[15px] font-medium leading-snug font-['ABeeZee'] text-left"}
                  style={{ color: highlighted ? '#FFFFFF' : '#000000' }}>
                  {item.descriptionText}
                </p>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ClientTrustDiagnosis
